class procedures {
      constructor(
            name) {
          this.id = name;
          this.text = name;
          
      }
      static fromJson({
            name
      }) {
          return new procedures(
            name
          );
      }
  }
  export default procedures;
  